/**
 * Quick 260813-iqd — self-service personal email PATCH client.
 *
 * Endpoint: PATCH /api/auth/me/personal-email (routes/auth.ts). Self-scope
 * only — the backend always writes the ACTING user's row (the route omits the
 * impersonate preHandler, so an admin impersonating someone cannot write the
 * target's PII). Body contract:
 *   { personalEmail: string | null }
 *   - a valid email address (max 254 chars) sets the value
 *   - `null` clears it
 *   - `''` is rejected server-side with 400 (clearing is null, not empty
 *     string — Fastify `format: 'email'` + Zod `.email()` defense-in-depth)
 * Every value-changing write is audited in state_changes with redacted
 * (<changed>) values — the address itself never lands in the audit trail.
 */

import { apiPatch } from './client';

export interface UpdatePersonalEmailResponse {
  data: {
    personalEmail: string | null;
  };
}

export function updatePersonalEmail(
  personalEmail: string | null,
): Promise<UpdatePersonalEmailResponse> {
  return apiPatch<UpdatePersonalEmailResponse>(`/auth/me/personal-email`, { personalEmail });
}
